const button = {
  fontFamily: `body`,
  fontSize: [1, null, 2],
  backgroundColor: 'transparent',
  fontWeight: 500,
  display: `inline-flex`,
  minWidth: `10rem`,
  alignItems: `center`,
  justifyContent: `space-evenly`,
  outline: 0,
  userSelect: `none`,
  WebkitTapHighlightColor: `transparent`,
  borderRadius: `8px`,
  cursor: `pointer`,
  whiteSpace: `pre`,
  transition: `all 250ms ease`,
  position: `relative`,
  zIndex: 0,
  px: `14px`,
  py: `10px`,
  '::after, ::before': {
    content: `" "`,
    position: `absolute`,
    zIndex: -2,
    height: `auto`,
    minHeight: [`44px`, null, null, `40px`],
    width: [`95%`, null, null, `100%`],
    borderRadius: `inherit`,
    borderWidth: `md`,
    borderStyle: `solid`,
    transitionDuration: `0.35s`,
  },
  '::after': {
    zIndex: -2,
  },
  '::before': {
    zIndex: -1,
    bg: `rgba(0,0,0,.05)`,
    borderColor: `transparent`,
    opacity: 0,
  },
  ':hover': {
    '::after': {
      bg: `primary600`,
      borderColor: `primary600`,
    },
  },
  ':active': {
    '::after': {
      bg: `primary600`,
      borderColor: `primary600`,
    },
  },
};

export default {
  button,
};
